module.exports = __webpack_public_path__ + "static/media/sign-in-background-megatec.acf8679c.jpg";